import { css, Global } from "@emotion/react";

const global = css`
    * {
        margin: 0;
        padding: 0;
        font-family: "Pretendard";
        border: none;
        box-sizing: border-box;
        ::-webkit-scrollbar {
            display: none;
        }
        user-select: none;
    }

    *::before,
    *::after {
    }

    h2 {
        font-size: 60px;
    }

    h3 {
        font-size: 52px;
    }

    h4 {
        font-size: 40px;
    }

    h5 {
        font-size: 32px;
    }

    h6 {
        font-size: 24px;
    }

    ul,
    li {
        list-style: none;
    }

    p {
        line-height: 1.5;
    }
    html,
    body {
        overflow-y: auto;
        height: 100%;
    }
    section {
        max-width: 1920px !important;
        width: 100%;

        & > div:first-of-type {
            max-width: 1600px;
            width: 100%;
        }
    }

    button {
        background: none;
        border-style: none;
    }
`;

const GlobalStyles = () => {
    return <Global styles={global}></Global>;
};

export default GlobalStyles;
